module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_kawamoto-6f681924f3ce19892f2c64899423c168.jpg";